import styled from 'styled-components';
import Color from '@/utils/color';

export const TimeSlotRow = styled.div<{ isErr?: boolean }>`
  background-color: ${(props) =>
    props.isErr ? Color.DangerRedBackground : ''};
  color: ${(props) => (props.isErr ? '' : '#495057')};
`;

// Re-export PrimeTimePicker for compatibility
export { PrimeTimePicker as StyledTimePicker } from './PrimeTimePicker';
